/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';
import type { RootState } from '../storeSetup';

interface CoachState {
  hasSeenWelcomeBanner: boolean;
}

const initialState: CoachState = {
  hasSeenWelcomeBanner: false,
};

export const coachSlice = createSlice({
  name: 'coach',
  initialState,
  reducers: {
    setWelcomeBannerSeen: (state) => {
      state.hasSeenWelcomeBanner = true;
    },
    resetCoachState: (state) => {
      state.hasSeenWelcomeBanner = false;
    },
  },
});

export const { setWelcomeBannerSeen, resetCoachState } = coachSlice.actions;

export const selectHasSeenWelcomeBanner = (state: RootState) => state.coach.hasSeenWelcomeBanner;

export default coachSlice.reducer;
